import { apiRequestActions } from '@ackee/redux-utils';

import { fetchElevatorStateTypes } from './types';

export default apiRequestActions(fetchElevatorStateTypes, { isDetailRequest: true });
